import './tailwind.css'
import './custom.css'

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { LoadingPanel } from './components/common/LoadingPanel'
import { ErrorBanner } from './components/common/ErrorBanner'
import { InfoBanner } from './components/common/InfoBanner';
import { Footer } from './components/common/page/Footer';

const UnsubscribeApp = () => {
    const [isLoading, setLoading] = useState(true)
    const [authDetails, setAuthDetails] = useState(null)
    const [error, setError] = useState(null)
    const [unsubscribeSuccessMessage, setUnsubscribeSuccessMessage] = useState(null)

    useEffect(() => {
        document.title = "Unsubscribe";

        // Get auth details
        const urlParams = new URLSearchParams(window.location.search);
        setAuthDetails({
            id: urlParams.get('id'),
            key: urlParams.get('key')
        })
    }, []);

    useEffect(() => {
        if (!authDetails) {
            return
        }

        if (!authDetails.id || !authDetails.key) {
            setError("Unable to unsubscribe as URL is incomplete.")
            setLoading(false)
            return
        }

        axios.post('/vote/unsubscribe', {
            id: authDetails.id,
            key: authDetails.key
        })
            .then((response) => {
                setUnsubscribeSuccessMessage(response.data)
            })
            .catch(function (error) {
                if (error.response?.data?.errorMessage) {
                    setError(error.response.data.errorMessage)
                }
                else {
                    setError(error)
                }
            })
            .finally(() => setLoading(false))
    }, [authDetails]);

    return (
        <div className="container" role="main">
            <LoadingPanel className="bg-white py-8 px-10 shadow sm:rounded-lg sm:mt-8 text-center"
                isLoading={isLoading}
                loadingText="Unsubscribing Voter..."
            />

            {!isLoading && error &&
                <div className="sm:mt-8">
                    <ErrorBanner>{error}</ErrorBanner>
                </div>
            }

            {!isLoading && unsubscribeSuccessMessage &&
                <div className="py-8">
                    <InfoBanner>
                        <>
                            <p className="mb-4">{unsubscribeSuccessMessage}</p>
                            <p>You will receive no further emails during the Ballot.</p>
                        </>
                    </InfoBanner>
                </div>
            }
            <Footer />
        </div >
    );
}

export default UnsubscribeApp;